import { SxProps, Theme } from "@mui/material";

export const settingCard: SxProps<Theme> = {
  p: 2.5,
  borderRadius: "12px",
  border: "1px solid rgba(1,67,57,0.1)",
  backgroundColor: "#fafaf6",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
};

export const settingSwitch: SxProps<Theme> = {
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#014339",
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#014339",
  },
};

export const settingLabel: SxProps<Theme> = {
  fontWeight: 600,
  fontSize: 15,
  color: "primary.main",
};

export const settingDescription: SxProps<Theme> = {
  fontSize: 13,
  color: "rgba(1,67,57,0.55)",
  mt: 0.5,
};
